






import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { Route, RawLocation } from 'vue-router'
import '@/icons/glasstype-lenses'
import '@/icons/glasstype-multifocal'
import '@/icons/glasstype-multifocalsunglasses'
import '@/icons/glasstype-reading'
import '@/icons/glasstype-screen'
import '@/icons/glasstype-single'
import '@/icons/glasstype-singlesunglasses'
import '@/icons/glasstype-sport'

@Component({
  computed: {
    ...mapState('cart', [
      'currentItem'
    ])
  }
})
export default class Glasses extends Vue {
  public currentItem!: object | undefined

  // @todo redirect to glasses if no currentItem is present
  public beforeRouteUpdate (
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
  ) {
    if (to.meta.requiresGlasses && this.currentItem === undefined) {
      next()
      // next('/glasses')
    } else {
      next()
    }
  }

  private mounted () {
    if (this.$store.state.route.from.fullPath === '/profile/glasses') {
      this.$store.dispatch('matrix/saveProfile')
        .catch((err) => console.error(err))
    }
  }
}
